export default {
  PedidosLog: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "pedidos-log"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/PedidosLog.js
// module id = 6jvS
// module chunks = 16